import {
  FETCH_PALETTES_REQUEST, FETCH_PALETTES_SUCCEEDED, FETCH_PALETTES_FAILED,
  FETCH_PALETTES_FOR_WORKSPACE_REQUEST, FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED, FETCH_PALETTES_FOR_WORKSPACE_FAILED,
  FETCH_PALETTE_FOLDERS_REQUEST, FETCH_PALETTE_FOLDERS_SUCCEEDED, FETCH_PALETTE_FOLDERS_FAILED,
  FETCH_COMPONENTS_FOR_PALETTE_REQUEST, FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED, FETCH_COMPONENTS_FOR_PALETTE_FAILED,
  FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST, FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED, FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED,
  FETCH_MEDIA_FOR_PALETTE_REQUEST, FETCH_MEDIA_FOR_PALETTE_SUCCEEDED, FETCH_MEDIA_FOR_PALETTE_FAILED,
  FETCH_PALETTE_COMPONENT_REQUEST, FETCHING_PALETTE_COMPONENT_SUCCEEDED, FETCHING_PALETTE_COMPONENT_FAILED
} from 'constants/actionTypes';

import _ from 'lodash'

const initialState = {
  default: {
    loading: false,
    fetched: false,
    invalidated: true,
    items: []
  },
  brandkit: {
    loading: false,
    fetched: false,
    invalidated: true,
    items: []
  }
}

const initialPaletteFolderState = {
  loading: false,
  fetched: false,
  items: []
}

const initialPaletteState = {
  loading: false,
  fetched: false,
  item: null,
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 0,
    totalRecordsCount: 0
  },
  folders: {
    loading: false,
    fetched: false,
    items: []
  }
}

const initialMediaState = {
  loading: false,
  fetched: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 0,
    totalRecordsCount: 0
  },
}

export function paletteReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_PALETTES_REQUEST: {
      return {
        ...state,
        default: {
          ...state.default,
          loading: true
        }
      }
    }

    case FETCH_PALETTES_SUCCEEDED: {
      const { response } = action.payload;

      return {
        ...state,
        default: {
          ...state.default,
          loading: false,
          items: response
        }
      }
    }

    case FETCH_PALETTES_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        default: {
          ...state.default,
          loading: false,
          error: error
        }
      }
    }

    case FETCH_PALETTES_FOR_WORKSPACE_REQUEST: {
      return {
        ...state,
        brandkit: {
          ...state.brandkit,
          loading: true
        }
      }
    }

    case FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED: {
      const { response } = action.payload;

      return {
        ...state,
        brandkit: {
          ...state.brandkit,
          loading: false,
          items: response
        }
      }
    }

    case FETCH_PALETTES_FOR_WORKSPACE_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        brandkit: {
          ...state.brandkit,
          loading: false,
          error: error
        }
      }
    }

    case FETCH_PALETTE_FOLDERS_REQUEST: {
      const { id, type } = action.payload;

      const paletteState = _.get(state, `${type}.${id}`, initialPaletteState);
      let paletteFolders = _.get(paletteState, 'folders', initialPaletteState.folders);
      paletteFolders = {
        ...paletteFolders,
        loading: true
      }


      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: paletteFolders
          }
        }
      }
    }

    case FETCH_PALETTE_FOLDERS_SUCCEEDED: {
      const { id, type, response } = action.payload;

      const paletteState = _.get(state, `${type}.${id}`, initialPaletteState);
      let paletteFolders = _.get(paletteState, 'folders', initialPaletteState.folders);
      paletteFolders = {
        ...paletteFolders,
        loading: false,
        fetched: true,
        items: response
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: paletteFolders
          }
        }
      }
    }

    case FETCH_PALETTE_FOLDERS_FAILED: {
      const { id, type, error } = action.payload;

      const paletteState = _.get(state, `${type}.${id}`, initialPaletteState);
      let paletteFolders = _.get(paletteState, 'folders', initialPaletteState.folders);
      paletteFolders = {
        ...paletteFolders,
        loading: false,
        fetched: false,
        error: error
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: paletteFolders
          }
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_REQUEST: {
      const { id, type, page } = action.payload;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);

      let items = _.get(paletteState, `items`, []);
      if(page === 0) {
        items = [];
      }

      let pagination = _.get(paletteState, `pagination`, {});
      if (page === 0) {
        pagination = {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 0,
          totalRecordsCount: 0
        }
      }

      paletteState = {
        ...paletteState,
        items: items,
        loading: true,
        fetched: page !== 0,
        pagination: pagination
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED: {
      const { id, type, response } = action.payload;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = response;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);
      
      var items = _.get(paletteState, 'items', []);

      if (currentPage !== 0) {
        items = [...items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');
      
      paletteState = {
        ...paletteState,
        items: items,
        loading: false,
        fetched: true,
        pagination: {
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_FAILED: {
      const { id, type, error } = action.payload;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);
      paletteState = {
        ...paletteState,
        loading: false,
        fetched: false,
        error: error
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_MEDIA_FOR_PALETTE_REQUEST: {
      const { id, type, mediaType, request } = action.payload;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);

      let mediaState = _.get(paletteState, mediaType, initialMediaState);

      let items = _.get(mediaState, `items`, []);
      if (request.page === 0) {
        items = [];
      }

      mediaState = {
        ...mediaState,
        loading: true,
        fetched: _.get(request, 'page', 0) !== 0,
        items: items
      }

      paletteState = {
        ...paletteState,
        [mediaType]: mediaState
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_MEDIA_FOR_PALETTE_SUCCEEDED: {
      const { id, type, mediaType, response } = action.payload;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);

      let mediaState = _.get(paletteState, mediaType, initialMediaState);

      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = response;

      var items = _.get(mediaState, 'items', []);

      if (currentPage !== 0) {
        items = [...items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      mediaState = {
        ...mediaState,
        items: items,
        loading: false,
        fetched: true,
        pagination: {
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }

      paletteState = {
        ...paletteState,
        [mediaType]: mediaState
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_MEDIA_FOR_PALETTE_FAILED: {
      const { id, type, mediaType, error } = action.payload;

      let paletteState = _.get(state, `${type}.${id}`, initialPaletteState);

      let mediaState = _.get(paletteState, mediaType, initialMediaState);

      mediaState = {
        ...mediaState,
        loading: false,
        fetched: false,
        error: error
      }

      paletteState = {
        ...paletteState,
        [mediaType]: mediaState
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: paletteState
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST: {
      const { id, type, folderId, page } = action.payload;

      let folderState = _.get(state, `${type}.${id}.folders.${folderId}`, initialPaletteFolderState);
      let items = _.get(folderState, `items`, []);
      if (page === 0) {
        items = [];
      }

      let pagination = _.get(folderState, `pagination`, {});
      if (page === 0) {
        pagination = {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 0,
          totalRecordsCount: 0
        }
      }

      folderState = {
        ...folderState,
        items: items,
        loading: true,
        fetched: page !== 0,
        pagination: pagination
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: {
              ...state[type][id].folders,
              [folderId]: folderState
            }
          }
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED: {
      const { id, type, folderId, response } = action.payload;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = response;

      let folderState = _.get(state, `${type}.${id}.folders.${folderId}`, initialPaletteFolderState);

      var items = _.get(folderState, 'items', []);
      
      if (currentPage !== 0) {
        items = [...items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      folderState = {
        ...folderState,
        items: items,
        loading: false,
        fetched: true,
        pagination: {
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: {
              ...state[type][id].folders,
              [folderId]: folderState
            }
          }
        }
      }
    }

    case FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED: {
      const { id, type, folderId, error } = action.payload;

      let folderState = _.get(state, `${type}.${id}.folders.${folderId}`, initialPaletteFolderState);
      folderState = {
        ...folderState,
        loading: false,
        fetched: false,
        error: error
      }

      return {
        ...state,
        [type]: {
          ...state[type],
          [id]: {
            ...state[type][id],
            folders: {
              ...state[type][id].folders,
              [folderId]: folderState
            }
          }
        }
      }
    }

    case FETCH_PALETTE_COMPONENT_REQUEST: {
      const id = action.payload;
      return {
        ...state,
        paletteComponent: {
          [id]: {
            loading: true,
            item: null
          }
        }
      }
    }

    case FETCHING_PALETTE_COMPONENT_SUCCEEDED: {
      const paletteComponent = action.payload;
      return {
        ...state,
        paletteComponent: {
          ...state.paletteComponent,
          [paletteComponent.id]: {
            loading: false,
            item: paletteComponent,
            fetched: true
          }
        }
      }
    }

    case FETCHING_PALETTE_COMPONENT_FAILED: {
      const { id, error } = action.payload;
      return {
        ...state,
        paletteComponent: {
          ...state.paletteComponent,
          [id]: {
            loading: false,
            item: null,
            error: error
          }
        }
      }
    }

    default:
      return state;
  }
}